import { create } from 'zustand';

// Theme mode type
export type ThemeMode = 'light' | 'dark';

// Utility functions for localStorage
const getStoredThemeMode = (): ThemeMode => {
  const stored = localStorage.getItem('themeMode');
  return stored === 'light' || stored === 'dark' ? stored : 'dark';
};

const setStoredThemeMode = (mode: ThemeMode) => {
  localStorage.setItem('themeMode', mode);
};

interface ThemeState {
  // Current theme mode
  mode: ThemeMode;

  // Theme mode actions
  setMode: (mode: ThemeMode) => void;
  toggleMode: () => void;

  // Initialization
  initializeTheme: () => void;
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  // Default to dark mode
  mode: 'dark',

  setMode: (mode: ThemeMode) => {
    set({ mode });
    setStoredThemeMode(mode);
  },

  toggleMode: () => {
    const currentMode = get().mode;
    const newMode = currentMode === 'light' ? 'dark' : 'light';
    get().setMode(newMode);
  },

  initializeTheme: () => {
    // Get stored mode or default to dark
    const storedMode = getStoredThemeMode();
    set({ mode: storedMode });
  },
}));
